import React from "react";
import {
  OuterContainer,
  Container,
  FormContainer,
  TableContainer,
  TableWrapper,
  FormControl,
  Row,
  ContainerGrid,
  Heading,
} from "./styles";
import ActionBar from "../../common/ActionBar/index";
import {
  PrimaryCTAButton,
  PrimaryOutlinedCTAButton,
} from "../../common/Buttons";
import FormField from "../../common/FormField/FormField";
import { Formik } from "formik";
import { hostValidationSchema } from "../../../helpers/validationSchema";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import HostService from "../../../services/HostService";
import { useState } from "react";
import { useEffect } from "react";
import { navigate } from "@reach/router";
import useUser from "../../../hooks/useUser";
import useStatus from "../../../hooks/useStatus";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { CustomCheckBox } from "../../common/FormInputs";

const CreateHost = () => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [orgIds, setOrgIds] = useState([{ label: "", name: "" }]);
  const { userObject } = useUser();
  const { status, setStatus } = useStatus();
  const inputs = [
    {
      type: "text",
      name: "firstName",
      label: "First Name",
      required: true,
    },
    {
      type: "text",
      name: "lastName",
      label: "Last Name",
      required: false,
    },
    {
      type: "email",
      name: "mailId",
      label: "Email ID",
      required: true,
    },
    {
      type: "mobile",
      name: "contactNumber",
      label: "Contact Number",
      required: true,
    },
    {
      type: "text",
      name: "department",
      label: "Department",
      required: false,
    },
    {
      type: "text",
      name: "designation",
      label: "Designation",
      required: false,
    },
  ];

  async function onFormSubmit(values, { resetForm }) {
    try {
      setLoader({ state: true });
      const payload = {
        ...values,
        textQuestion: values?.textQuestion ? 1 : 0,
        videoQuestion: values?.videoQuestion ? 1 : 0,
        sendPolls: values?.sendPolls ? 1 : 0,
        sendTickers: values?.sendTickers ? 1 : 0,
        viewRegistrations: values?.viewRegistrations ? 1 : 0,
        uploadResources: values?.uploadResources ? 1 : 0,
        viewCommunicateResponses: values?.viewCommunicateResponses ? 1 : 0,
        viewQuestions: values?.viewQuestions ? 1 : 0,
        viewFeedback: values?.viewFeedback ? 1 : 0,
        viewPollResponses: values?.viewPollResponses ? 1 : 0,
        viewResourceAccessed: values?.viewResourceAccessed ? 1 : 0,
        approveRegistrants: values?.approveRegistrants ? 1 : 0,
      };
      const response = await HostService.createHost(payload);
      if (response) {
        enqueueSnackbar("Host created successfully", {
          variant: "success",
        });
      }
      resetForm();
      navigate(`/dashboard/eventmanager/event-hosts/view-hosts`, {
        state: {
          orgId: values?.orgId,
        },
      });
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  useEffect(() => {
    (async function getOrganizationData() {
      try {
        const response = await HostService.activeOrganisation();
        setOrgIds(
          response?.organizations?.map((item) => {
            return {
              label: item.orgName,
              value: item.orgId,
            };
          }),
        );
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status?.hostStatus) {
      enqueueSnackbar("Creation of host is not permitted", {
        variant: "warning",
      });
      setStatus({ status: false });
      window.scrollTo(0, 0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const input_checkbox = [
    {
      label: "Text Question",
      name: "textQuestion",
      type: "checkbox",
    },
    {
      label: "Video Question",
      name: "videoQuestion",
      type: "checkbox",
    },
    {
      label: "Send Polls",
      name: "sendPolls",
      type: "checkbox",
    },
    {
      label: "Send Tickers",
      name: "sendTickers",
      type: "checkbox",
    },
    {
      label: "View Registration",
      name: "viewRegistrations",
      type: "checkbox",
    },
    {
      label: "Upload Resources",
      name: "uploadResources",
      type: "checkbox",
    },
    {
      label: "View Communicate",
      name: "viewCommunicateResponses",
      type: "checkbox",
    },
    {
      label: "View Questions",
      name: "viewQuestions",
      type: "checkbox",
    },
    {
      label: "View Feedback",
      name: "viewFeedback",
      type: "checkbox",
    },
    {
      label: "ViewPoll Response",
      name: "viewPollResponse",
      type: "checkbox",
    },
    {
      label: "View ResourceAccessed",
      name: "viewResourceAccessed",
      type: "checkbox",
    },
    {
      label: "Approve Registrants",
      name: "approveRegistrants",
      type: "checkbox",
    },
  ];

  return (
    <OuterContainer
      disabled={userObject?.createModifyHost === 0 ? true : false}
    >
      <ActionBar breadcrumbs={["Event Host"]} />
      <Container>
        <Heading>Create Host</Heading>
        <Formik
          initialValues={{
            createModify: 1,
            orgId: "",
            firstName: "",
            lastName: "",
            mailId: "",
            contactNumber: "",
            department: "",
            designation: "",
            sendPolls: false,
            textQuestion: false,
            videoQuestion: false,
            sendTickers: false,
            viewRegistrations: false,
            uploadResources: false,
            viewCommunicateResponses: false,
            viewQuestions: false,
            viewFeedback: false,
            viewPollResponses: false,
            viewResourceAccessed: false,
            approveRegistrants: false,
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validationSchema={hostValidationSchema}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            handleChange,
            errors,
            handleSubmit,
            touched,
            handleBlur,
            setFieldValue,
            isValid,
            isSubmitting,
          }) => (
            <FormContainer onSubmit={handleSubmit}>
              <TableContainer>
                <TableWrapper>
                  <FormField
                    white
                    input={{
                      type: "typeSelect",
                      name: "orgId",
                      label: "Organisation Name",
                      required: true,
                      autoWidth: true,
                    }}
                    menuItems={orgIds}
                    {...{
                      values,
                      handleChange,
                      errors,
                      handleSubmit,
                      touched,
                      handleBlur,
                      setFieldValue,
                      isSubmitting,
                    }}
                  />
                  <ContainerGrid>
                    {inputs.map((input, index) => {
                      return (
                        <FormField
                          key={index}
                          {...{
                            touched,
                            errors,
                            input,
                            values,
                            handleChange,
                            handleBlur,
                            setFieldValue,
                            isSubmitting,
                          }}
                        />
                      );
                    })}
                  </ContainerGrid>
                  <CheckboxGrid>
                    {input_checkbox.map((pre, index) => (
                      <CheckboxContainer>
                        <CustomCheckBox
                          checkboxmargin
                          disabled={pre?.disabled}
                          type={pre?.type}
                          value={values[pre?.name]}
                          checked={values[pre?.name]}
                          error={errors[pre?.name] && touched[pre?.name]}
                          helperText={touched[pre?.name] && errors[pre?.name]}
                          id={pre?.name}
                          name={pre?.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <CheckBoxLabel>{pre.label} </CheckBoxLabel>
                      </CheckboxContainer>
                    ))}
                  </CheckboxGrid>
                </TableWrapper>
              </TableContainer>
              <FormControl>
                <Row>
                  <PrimaryCTAButton
                    onClick={handleSubmit}
                    style={{ width: "112px" }}
                  >
                    Create
                  </PrimaryCTAButton>
                  <PrimaryOutlinedCTAButton
                    onClick={() =>
                      navigate(
                        `/dashboard/eventmanager/event-hosts/view-event-host`,
                      )
                    }
                    style={{ width: "112px" }}
                  >
                    Cancel
                  </PrimaryOutlinedCTAButton>
                </Row>
              </FormControl>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

export default CreateHost;

export const CheckboxGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin-top: 15px;
  @media ${theme?.breakpoints?.sm_up} {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    padding: 0;
    border-radius: 0;
    background-color: transparent;
  }
`;

export const CheckBoxLabel = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.COLOR_DARK};
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  @media ${theme.breakpoints.sm_up} {
    width: 100%;
  }
`;
